var React = require('react');

function ScrollDownArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon_scroll_arrows_left"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Icon_scroll_arrows_left","transform":"translate(10.500000, 5.000000) rotate(-90.000000) translate(-10.500000, -5.000000) translate(5.000000, -5.000000)","strokeWidth":"0.7","stroke":"#E5E5E5"},React.createElement("g",{"id":"Icon_scroll_arrows","transform":"translate(5.500000, 10.000000) rotate(-180.000000) translate(-5.500000, -10.000000) translate(0.000000, 0.000000)"},React.createElement("polygon",{"id":"Shape","points":"0.89 0.66 10.15 9.93 0.89 19.19","style":{"fill":"#E5E5E5"}}))))]);
}

ScrollDownArrow.defaultProps = {"width":"20px","height":"10px","viewBox":"0 0 20 10","version":"1.1"};

module.exports = ScrollDownArrow;

ScrollDownArrow.default = ScrollDownArrow;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/assets/Scroll_Down_Arrow.svg
// module id = 534
// module chunks = 0